import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/appApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      detectCountry(res.data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const detectCountry = async (u) => {
    if (!u || u.country) return;
    try {
      const r = await fetch("https://ipapi.co/country/");
      const code = (await r.text()).trim();
      if (/^[A-Za-z]{2}$/.test(code)) {
        const res = await api.post("/profile/country", { country: code });
        setUser(res.data);
      }
    } catch (e) {}
  };

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, detectCountry, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
